import React from 'react';

import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import { isLogin } from './utils/isLogin';

import './styles/App.css';
import "@amir04lm26/react-modern-calendar-date-picker/lib/DatePicker.css";

// pages
import Login from './view/auth/login';
import Panel from './components/pages/panel/panel.layout';
import Guest from './view/panel/Guest';
import Setting from './view/panel/setting';
import RoomPrice from './view/panel/roomPrice';
import Guests from './view/panel/guests';
import { getStatus } from './services/getApi';
import ReportsPrint from 'components/pages/repotsPrint';

function App() {
  const redirect = useNavigate();

  React.useEffect(() => {
    getStatus().then(_ => {
      console.log('ok')
    })
      .catch(_ => {
        redirect('/login');
        localStorage.removeItem("token");
        localStorage.removeItem("validityTime");
      })
  }, [])

  return (
    <div className="App">
      <Routes>
        <Route path='/login' element={<Login />} />
        <Route path='/print' element={<ReportsPrint />} />
        <Route path="/" element={<Panel />}>
          <Route path='setting' element={<Setting />} />
          <Route path='guests' element={<Guests />} />
          <Route path='room-price' element={<RoomPrice />} />
          <Route path='print/:id' />
          <Route path='new-guest'>
            <Route path="person" />
            <Route path="room" />
            <Route path="check" />
          </Route>
          <Route path='new-factor' />
          <Route path='new-store' />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
